var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{on:{"click":_vm.showVideoBtn}},[_c('div',{staticClass:"video-cover",style:({
      'background-image': 'url(' + _vm.videoImg + ')',
    })},[_c('img',{attrs:{"src":require("@/assets/img/play.svg"),"alt":""}})]),_c('h3',[_vm._v(_vm._s(_vm.tit))]),_c('p',[_vm._v(_vm._s(_vm.txt))])])}
var staticRenderFns = []

export { render, staticRenderFns }